import { DomainGuid, FunctionalGridElementTypes } from "@/features/execute-calculation-set/overmind/calculation/grid/FunctionalGrid";
import { useAppState } from "@/overmind";

export const useIsGridElementType: () => IsGridElementFunction = () => {
  const state = useAppState().calculation.calculationTactic;
  if (state.current === 'LOADED' && state.value.status === 'Completed') {
    const functionalGrid = state.value.calculationSetResult.grid.functional;

    return (gridElementType, globalId) => {
      switch (gridElementType) {
        case 'PowerTransformer':
          return functionalGrid.powerTransformers.some(
            transformer => transformer.objectId === globalId
          );
        case 'PowerTransformerEnd':
          return functionalGrid.powerTransformerEnds.some(
            substation => substation.objectId === globalId
          );
        case 'Busbar':
          return functionalGrid.mediumVoltageBusbars.some(
            busbar => busbar.objectId === globalId
          );
        case 'Switch':
          return functionalGrid.switches.some(
            switchElement => switchElement.objectId === globalId
          );
        case 'AcLineSegment':
          return functionalGrid.acLineSegments.some(
            line => line.objectId === globalId
          );
        case 'Terminal':
          return functionalGrid.terminals.some(
            terminal => terminal.objectId === globalId
          );
        case 'EnergyConsumer':
          return functionalGrid.energyConsumers.some(
            consumer => consumer.objectId === globalId
          );
        case 'ExternalNetworkInjection':
          return functionalGrid.externalNetworkInjections.some(
            injection => injection.objectId === globalId
          );
        case 'ConnectivityNode':
          return functionalGrid.connectivityNodes.some(
            node => node.objectId === globalId
          );
        // WARNING - don't add default! All types should be always handled and verified by type checker.
      }
    };
  }
  return () => false; // TODO: Consider returning object instead of boolean. Object should hold information if functionalGrid was loaded and completed like {value: boolean, type: 'READY' | 'NOT_READY' } or just string 'YES' | 'NO' | 'UNKNOWN'. Or return not function but GridElementVerifier type that will have state 'READY' | 'NOT_READY' and will be able to do verification. Then then will be no need to check if ready in every verification.
};

export type IsGridElementFunction = (
  gridElementType: FunctionalGridElementTypes,
  globalId: DomainGuid
) => boolean;
